// src/services/firebase.ts
import { initializeApp, getApp } from "firebase/app";
import { getAnalytics, initializeAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider, getToken } from "firebase/app-check";
import { getAuth, signInAnonymously, onAuthStateChanged, type User } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBNAbBCD3wdCqeUEMaUtKXtuGZUhysxxdo",
  authDomain: "koent-domain-sentinel.firebaseapp.com",
  projectId: "koent-domain-sentinel",
  storageBucket: "koent-domain-sentinel.firebasestorage.app",
  messagingSenderId: "695560652826",
  appId: "1:695560652826:web:4627b8709a00cfb0f2e9a3",
  measurementId: "G-FV267Q8MEW"
};

export const getFirebaseFunctionUrl = (functionName: string) => {
  const projectId = 'koent-domain-sentinel';
  const region = 'europe-west1';

  if (import.meta.env.DEV) {
    // Emulator URL
    return `http://127.0.0.1:5051/${projectId}/${region}/${functionName}`;
  } else {
    // Production URL
    return `https://${region}-${projectId}.cloudfunctions.net/${functionName}`;
  }
};
// Function to get the correct WebSocket proxy URL based on the environment
export const getWebSocketUrl = (functionName: string, token: string): string => {
  const host = window.location.host;
  const protocol = host.includes('localhost') || host.includes('127.0.0.1') ? 'ws' : 'wss';
  const baseUrl = protocol === 'ws'
    ? `ws://127.0.0.1:5051/koent-domain-sentinel/europe-west1/${functionName}`
    : `wss://europe-west1-koent-domain-sentinel.cloudfunctions.net/${functionName}`;

  return `${baseUrl}?token=${token}`;
};

// Initialize Firebase app and services
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = initializeAnalytics(app);
// self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
  //provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});
//getToken(appCheck);

let currentUser: User | null = null;
let idToken: string | null = null;

// Listen for auth state changes to keep the token fresh
onAuthStateChanged(auth, async (user) => {
  if (user) {
    currentUser = user;
    idToken = await user.getIdToken();
    // The token automatically refreshes, but we can force it if needed.
    // For this app, onAuthStateChanged should be sufficient.
  } else {
    currentUser = null;
    idToken = null;
  }
});

// Function to trigger anonymous sign-in
export const ensureAnonymousAuth = async () => {
  if (auth.currentUser) {
    return auth.currentUser;
  }
  try {
    const userCredential = await signInAnonymously(auth);
    return userCredential.user;
  } catch (error) {
    console.error("Anonymous sign-in failed:", error);
    return null;
  }
};

// Function to get the current user's ID token
export const getIdToken = async (): Promise<string | null> => {
  await ensureAnonymousAuth(); // Make sure we are signed in
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken(true); // Force refresh for latest token
  }
  return null;
};

